<h1>Security configuration</h1>

<section id="mfa-policy">
  <h2 class="section-title-row">MFA enforcement</h2>
  <p class="tp-section-info">Require all team members to log in using multi-factor authentication</p>
  <tp-form
    class="mfa-form"
    [formGroup]="mfaPolicyForm"
    [isSubmitting$]="mfaPolicyIsSubmitting$"
    (doSubmit)="submitMFAPolicyForm()"
  >
    <mat-form-field>
      <mat-label>Enforcement level</mat-label>
      <mat-select [formControl]="mfaPolicyForm.controls.mfaPolicy">
        <mat-select-trigger>{{ toSentenceCase(mfaPolicyForm.controls.mfaPolicy.value) }}</mat-select-trigger>
        @for (option of mfaPolicyOptions; track option) {
          <mat-option [value]="option.value">
            <div>
              <p>{{ toSentenceCase(option.value) }}</p>
              <aside>{{ option.description }}</aside>
            </div>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (mfaPolicyChanged && mfaPolicyForm.controls.mfaPolicy.value === 'mandatory') {
      <div class="admonitionblock attention">
        <div class="icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <p>
          Members who have not enabled MFA will be <strong>locked out of team resources immediately</strong>.
          Confirm that team members are not missing MFA on the <a routerLink="../../members">members page</a> before you select this option.
        </p>
      </div>
    }
    <tp-form-actions
      [isSubmitting]="mfaPolicyIsSubmitting$ | async"
      [submitDisabled]="!mfaPolicyChanged"
      [cancelDisabled]="!mfaPolicyChanged"
      [cancellable]="true"
      (cancel)="mfaPolicyForm.reset()"
      buttonIdPrefix="editMFAPolicy"
      submitText="Save"
      cancelText="Reset"
    ></tp-form-actions>
  </tp-form>
</section>

<section id="team-admins">
  <tp-table-toolbar [table]="admins" filterGroupId="admins" tableTitle="Team admins" headerLevel="h2" [actions]="[addAdminButton]"/>
  <p class="tp-section-info">View and configure users with administrator access</p>
  <tp-users-table [table]="admins" [rowPopupMenuItems]="adminsTableRowPopupMenuItems"/>
  <tp-table-paginator [table]="admins"/>
</section>

<section id="security-contacts">
  <h2 class="section-title-row">Security contacts</h2>
  <p class="tp-section-info">Set contact emails for important TypeDB Cloud security bulletins</p>
  <tp-form
    class="contacts-form"
    [formGroup]="securityContactsForm"
    [isSubmitting$]="securityContactsIsSubmitting$"
    (doSubmit)="submitSecurityContactsForm()"
  >
    <mat-form-field>
      <mat-label>Security contacts</mat-label>
      <mat-chip-grid #securityContactChips [formControl]="securityContactsForm.controls.securityContacts">
        @for (contact of securityContacts; track contact) {
          <mat-chip-row (removed)="removeSecurityContact(contact)">
            {{contact}}
            <button matChipRemove>
              <i class="fa-light fa-xmark"></i>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input
        placeholder="Add security contact..."
        [matChipInputFor]="securityContactChips"
        matChipInputAddOnBlur
        [matChipInputSeparatorKeyCodes]="securityContactSeparatorKeysCodes"
        (matChipInputTokenEnd)="addSecurityContact($event)"
      />
      @if (securityContactsForm.controls.securityContacts.invalid) {
        <mat-error>{{securityContactsForm.controls.securityContacts.getError("errorText")}}</mat-error>
      }
    </mat-form-field>
    <tp-form-actions
      [isSubmitting]="securityContactsIsSubmitting$ | async"
      [submitDisabled]="!securityContactsChanged"
      [cancelDisabled]="!securityContactsChanged"
      [cancellable]="true"
      (cancel)="resetSecurityContacts()"
      buttonIdPrefix="editSecurityContacts"
      submitText="Save"
      cancelText="Reset"
    ></tp-form-actions>
  </tp-form>
</section>
